export const CONTACT_EMAIL = 'kontakt@elfedu.pl';
